export const defaultToolbarButtons = [
   [
      'undo',
      'redo',
      '|',
      'insertLink',
      'insertTable',
      'insertImage',
      '|',
      'insertHR',
      'specialCharacters',
      'clearFormatting',
   ],
   ['fontFamily', 'fontSize', '|', 'backgroundColor', 'textColor', '|', 'outdent', 'indent'],
   [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      '|',
      'formatUL',
      'formatOL',
      'align',
      '|',
      'showAdvancedToolbar',
      'hideAdvancedToolbar',
   ],
]

export const toolbarButtonsWithVideo = [
   [
      'undo',
      'redo',
      '|',
      'insertLink',
      'insertTable',
      'insertImage',
      '|',
      'insertHR',
      'specialCharacters',
      'clearFormatting',
      'insertVideo',
   ],
   [
      ,
      'fontFamily',
      'fontSize',
      '|',
      'backgroundColor',
      'textColor',
      '|',
      'outdent',
      'indent',
      'emoticons',
   ],
   [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      '|',
      'formatUL',
      'formatOL',
      'align',
      '|',
      'showAdvancedToolbar',
      'hideAdvancedToolbar',
   ],
]

export const pluginsWithVideo = [
   'align',
   'colors',
   'draggable',
   'entities',
   'fontFamily',
   'fontSize',
   'specialCharacters',
   'image',
   'lineBreaker',
   'link',
   'lists',
   'table',
   'url',
   'wordPaste',
   'video',
   'emoticons',
]

export const defaultPlugins = [
   'align',
   'colors',
   'draggable',
   'entities',
   'fontFamily',
   'fontSize',
   'specialCharacters',
   'image',
   'lineBreaker',
   'link',
   'lists',
   'table',
   'url',
   'wordPaste',
] // 'video', 'emoticons',

export const defaultFonts = {
   'Roboto,Verdana,sans-serif': 'Roboto',
   'Verdana,Geneva,sans-serif': 'Verdana',
   'Tahoma,Geneva,sans-serif': 'Tahoma',
   'Arial,Helvetica,sans-serif': 'Arial',
   'Helvetica,Arial,sans-serif': 'Helvetica',
   'Impact,Charcoal,sans-serif': 'Impact',
   "'Times New Roman',Times,serif": 'Times New Roman',
   'Georgia,serif': 'Georgia',
}

export const specialCharactersSets = [
   {
      title: 'Arrows',
      list: [
         { char: '&#x2190', desc: 'LEFTWARDS ARROW' },
         { char: '&#x2191', desc: 'UPWARDS ARROW' },
         { char: '&#x2192', desc: 'RIGHTWARDS ARROW' },
         { char: '&#x2193', desc: 'DOWNWARDS ARROW' },
         { char: '&#x2194', desc: 'LEFT RIGHT ARROW' },
         { char: '&#x2195', desc: 'UP DOWN ARROW' },
         { char: '&#x2196', desc: 'NORTH WEST ARROW' },
         { char: '&#x2197', desc: 'NORTH EAST ARROW' },
         { char: '&#x2198', desc: 'SOUTH EAST ARROW' },
         { char: '&#x2199', desc: 'SOUTH WEST ARROW' },
         { char: '&#x21C4', desc: 'RIGHTWARDS ARROW OVER LEFTWARDS ARROW' },
         { char: '&#x21C5', desc: 'UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW' },
         { char: '&#x21C6', desc: 'LEFTWARDS ARROW OVER RIGHTWARDS ARROW' },
         { char: '&#x21C7', desc: 'LEFTWARDS PAIRED ARROWS' },
         { char: '&#x21C8', desc: 'UPWARDS PAIRED ARROWS' },
         { char: '&#x21C9', desc: 'RIGHTWARDS PAIRED ARROWS' },
         { char: '&#x21CA', desc: 'DOWNWARDS PAIRED ARROWS' },
         { char: '&#x21D0', desc: 'LEFTWARDS DOUBLE ARROW' },
         { char: '&#x21D1', desc: 'UPWARDS DOUBLE ARROW' },
         { char: '&#x21D2', desc: 'RIGHTWARDS DOUBLE ARROW' },
         { char: '&#x21D3', desc: 'DOWNWARDS DOUBLE ARROW' },
         { char: '&#x21D4', desc: 'LEFT RIGHT DOUBLE ARROW' },
         { char: '&#x21D5', desc: 'UP DOWN DOUBLE ARROW' },
         { char: '&#x21D6', desc: 'NORTH WEST DOUBLE ARROW' },
         { char: '&#x21D7', desc: 'NORTH EAST DOUBLE ARROW' },
         { char: '&#x21D8', desc: 'SOUTH EAST DOUBLE ARROW' },
         { char: '&#x21D9', desc: 'SOUTH WEST DOUBLE ARROW' },
         { char: '&#x21DA', desc: 'LEFTWARDS TRIPLE ARROW' },
         { char: '&#x21DB', desc: 'RIGHTWARDS TRIPLE ARROW' },
         { char: '&#x21E6', desc: 'LEFTWARDS WHITE ARROW' },
         { char: '&#x21E7', desc: 'UPWARDS WHITE ARROW' },
         { char: '&#x21E8', desc: 'RIGHTWARDS WHITE ARROW' },
         { char: '&#x21E9', desc: 'DOWNWARDS WHITE ARROW' },
         { char: '&#x21FD', desc: 'LEFTWARDS OPEN-HEADED ARROW' },
         { char: '&#x21FE', desc: 'RIGHTWARDS OPEN-HEADED ARROW' },
         { char: '&#x21FF', desc: 'LEFT RIGHT OPEN-HEADED ARROW' },
      ],
   },
   {
      title: 'Math',
      list: [
         { char: '&empty;', desc: 'EMPTY SET' },
         { char: '&isin;', desc: 'ELEMENT OF' },
         { char: '&notin;', desc: 'NOT AN ELEMENT OF' },
         { char: '&ni;', desc: 'CONTAINS AS MEMBER' },
         { char: '&sum;', desc: 'N-ARY SUMMATION' },
         { char: '&radic;', desc: 'SQUARE ROOT' },
         { char: '&prop;', desc: 'PROPORTIONAL TO' },
         { char: '&infin;', desc: 'INFINITY' },
         { char: '&cap;', desc: 'INTERSECTION' },
         { char: '&cup;', desc: 'UNION' },
         { char: '&int;', desc: 'INTEGRAL' },
         { char: '&there4;', desc: 'THEREFORE' },
         { char: '&sim;', desc: 'TILDE OPERATOR' },
         { char: '&cong;', desc: 'APPROXIMATELY EQUAL TO' },
         { char: '&asymp;', desc: 'ALMOST EQUAL TO' },
         { char: '&ne;', desc: 'NOT EQUAL TO' },
         { char: '&equiv;', desc: 'IDENTICAL TO' },
         { char: '&le;', desc: 'LESS-THAN OR EQUAL TO' },
         { char: '&ge;', desc: 'GREATER-THAN OR EQUAL TO' },
         { char: '&sub;', desc: 'SUBSET OF' },
         { char: '&sup;', desc: 'SUPERSET OF' },
         { char: '&nsub;', desc: 'NOT A SUBSET OF' },
         { char: '&sube;', desc: 'SUBSET OF OR EQUAL TO' },
         { char: '&supe;', desc: 'SUPERSET OF OR EQUAL TO' },
      ],
   },
   {
      title: 'Misc',
      list: [
         { char: '&spades;', desc: 'BLACK SPADE SUIT' },
         { char: '&clubs;', desc: 'BLACK CLUB SUIT' },
         { char: '&hearts;', desc: 'BLACK HEART SUIT' },
         { char: '&diams;', desc: 'BLACK DIAMOND SUIT' },
         { char: '&#x2669', desc: 'QUARTER NOTE' },
         { char: '&#x266A', desc: 'EIGHTH NOTE' },
         { char: '&#x266B', desc: 'BEAMED EIGHTH NOTES' },
         { char: '&#x266C', desc: 'BEAMED SIXTEENTH NOTES' },
         { char: '&#x266D', desc: 'MUSIC FLAT SIGN' },
         { char: '&#x266E', desc: 'MUSIC NATURAL SIGN' },
         { char: '&#x2714', desc: 'HEAVY CHECK MARK' },
         { char: '&#x2716', desc: 'HEAVY MULTIPLICATION X' },
         { char: '&#x2764', desc: 'HEAVY BLACK HEART' },
      ],
   },
]
